module.exports = __webpack_public_path__ + "img/htcm_11.bf2407d2.jpg";